import { Service } from 'app/modules/service/components/Service/Service';

export const ServicePage = (): JSX.Element => <Service />;
